import {ContainerModule} from 'inversify';

import {
  BaseNavigationService,
  BaseNavigationServiceImpl,
} from './BaseNavigation.service';

export const registerBaseNavigation = (
  onActivationCallback: (
    service: BaseNavigationService,
  ) => BaseNavigationService,
) => {
  return new ContainerModule(options => {
    options
      .bind<BaseNavigationService>(BaseNavigationService)
      .to(BaseNavigationServiceImpl)
      .inSingletonScope()
      .onActivation((_context, service) => {
        return onActivationCallback(service);
      });
  });
};
